/* Igor 2026-10-15: el social proof "Le clienti che l'hanno gia" (.mf-fc, que assets/tabla-fotos-claude.js pinta dentro de la columna de la ficha) sale SIEMPRE como seccion propia justo debajo de la seccion de producto (fuera de la descripcion), en movil y ordenador. Movil: mismo tamano que antes. Ordenador (>=990px): ancho de pagina con 4 fotos. El carrusel nunca se pausa (ni hover, ni dedo, ni prefers-reduced-motion). Reversible: quitar este script de sections/scialli-cambia-claude.liquid. */
(function () {
  if (window.__mfSpOut) return; window.__mfSpOut = true;
  var cssDone = false;
  function keep() {
    var st = document.createElement('style');
    st.textContent =
      'html body .mf-fc .mf-fc__m,html body mf-product-information .mf-fc .mf-fc__m{pointer-events:none!important;-webkit-user-select:none;user-select:none}' +
      'html body .mf-fc:not(.is-static) .mf-fc__tr{animation-play-state:running!important}' +
      '@media (prefers-reduced-motion:reduce){html body .mf-fc:not(.is-static) .mf-fc__tr{animation:mf-fc-mq var(--mf-fc-t,40s) linear infinite!important;animation-play-state:running!important}html body .mf-fc .mf-fc__m{overflow-x:hidden!important}}';
    document.head.appendChild(st);
  }
  function css() {
    if (cssDone) return;
    var src = Array.prototype.find.call(document.querySelectorAll('style'), function (s) {
      return s.textContent.indexOf('mf-product-information .mf-fc__t') > -1;
    });
    if (!src) return;
    cssDone = true;
    var t = src.textContent.split('html body mf-product-information ').join('html body .mf-fc-out ');
    t += '.mf-fc-out{background:#fff;padding:0 16px}' +
      'html body .mf-fc-out .mf-fc__m:hover .mf-fc__tr{animation-play-state:running!important}' +
      '@media (min-width:990px){' +
      '.mf-fc-out{padding:48px 0 40px}' +
      '.mf-fc-out__in{max-width:1200px;margin:0 auto;padding:0 20px}' +
      'html body .mf-fc-out .mf-fc{margin:0}' +
      'html body .mf-fc-out .mf-fc__t{font-size:34px!important;gap:16px;margin-bottom:24px}' +
      'html body .mf-fc-out .mf-fc__h{width:24px;height:24px}' +
      'html body .mf-fc-out .mf-fc__s{width:calc(100cqw / 4 - 10px)}' +
      'html body .mf-fc-out .mf-fc.is-static .mf-fc__tr{justify-content:center}' +
      'html body .mf-fc-out .mf-fc.is-static .mf-fc__s{margin:0 5px}' +
      'html body .mf-fc-out .mf-fc__soc{margin-top:24px}}';
    var st = document.createElement('style');
    st.textContent = t;
    document.head.appendChild(st);
  }
  function ph() {
    var e = document.createElement('div');
    e.className = 'mf-fc'; e.hidden = true; e.setAttribute('data-mf-ph', '');
    return e;
  }
  function run() {
    var r = document.querySelector('mf-product-information');
    if (!r) return;
    css();
    var out = document.querySelector('.mf-fc-out');
    var inner = r.querySelector('.mf-fc:not([data-mf-ph])');
    var outer = out && out.querySelector('.mf-fc');
    if (outer) { if (inner) inner.parentNode.replaceChild(ph(), inner); return; }
    if (!inner) return;
    var host = r.closest('.shopify-section') || r;
    out = document.createElement('div');
    out.className = 'mf-fc-out';
    out.innerHTML = '<div class="mf-fc-out__in"></div>';
    host.parentNode.insertBefore(out, host.nextSibling);
    inner.parentNode.replaceChild(ph(), inner);
    out.firstChild.appendChild(inner);
  }
  var q = false;
  function sched() { if (q) return; q = true; requestAnimationFrame(function () { q = false; run(); }); }
  function init() {
    keep();
    run();
    new MutationObserver(sched).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();